export enum CartStep {
  TestsAvailable,
  ShoppingCart,
  PanelDetails,
  Consent,
  Physician,
  PaymentAddress,
  Payment,
  PaymentSuccess,
  PaymentProblem,
  Unknown,
}
